import React, { useState, useEffect } from "react";
import { Card, Form, Button, Spinner, Alert } from "react-bootstrap";
import notificationApi from "@/api/notificationApi";

const NotificationSettings = () => {
  const [preferences, setPreferences] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    fetchPreferences();
  }, []);

  const fetchPreferences = async () => {
    try {
      setLoading(true);
      const response = await notificationApi.getPreferences();
      setPreferences(response.data);
    } catch (error) {
      console.error("Error fetching preferences:", error);
      setMessage({ type: "danger", text: "Sozlamalarni yuklashda xatolik" });
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = (field) => {
    setPreferences((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleTimeChange = (field, value) => {
    setPreferences((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      setMessage(null);

      await notificationApi.updatePreferences(preferences);
      setMessage({ type: "success", text: "Sozlamalar muvaffaqiyatli saqlandi!" });

      // Auto-hide success message after 3 seconds
      setTimeout(() => setMessage(null), 3000);
    } catch (error) {
      console.error("Error saving preferences:", error);
      setMessage({ type: "danger", text: "Sozlamalarni saqlashda xatolik" });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!preferences) {
    return (
      <Alert variant="danger">
        Sozlamalarni yuklab bo'lmadi. Sahifani yangilang.
      </Alert>
    );
  }

  return (
    <div className="content">
      <Card>
        <Card.Header>
          <h5 className="title">Bildirishnoma Sozlamalari</h5>
          <p className="category">Qaysi bildirishnomalarni olishni sozlang</p>
        </Card.Header>
        <Card.Body>
          {message && (
            <Alert variant={message.type} className="mb-4">
              {message.text}
            </Alert>
          )}

          <Form>
            {/* Task Notifications */}
            <h6 className="mb-3">Vazifa Bildirish nomalari</h6>

            <Form.Check className="mb-2">
              <Form.Check.Input
                type="checkbox"
                checked={preferences.task_created_enabled}
                onChange={() => handleToggle("task_created_enabled")}
              />
              <Form.Check.Label>
                Yangi vazifa yaratilganda
              </Form.Check.Label>
            </Form.Check>

            <Form.Check className="mb-2">
              <Form.Check.Input
                type="checkbox"
                checked={preferences.task_assigned_enabled}
                onChange={() => handleToggle("task_assigned_enabled")}
              />
              <Form.Check.Label>
                Vazifa menga biriktirilganda
              </Form.Check.Label>
            </Form.Check>

            <Form.Check className="mb-2">
              <Form.Check.Input
                type="checkbox"
                checked={preferences.task_status_changed_enabled}
                onChange={() => handleToggle("task_status_changed_enabled")}
              />
              <Form.Check.Label>
                Vazifa holati o'zgarganda
              </Form.Check.Label>
            </Form.Check>

            <Form.Check className="mb-4">
              <Form.Check.Input
                type="checkbox"
                checked={preferences.task_deadline_reminder_enabled}
                onChange={() => handleToggle("task_deadline_reminder_enabled")}
              />
              <Form.Check.Label>
                Muddat yaqinlashganda eslatma
              </Form.Check.Label>
            </Form.Check>

            {/* Event Notifications */}
            <h6 className="mb-3">Tadbir Bildirish nomalari</h6>

            <Form.Check className="mb-2">
              <Form.Check.Input
                type="checkbox"
                checked={preferences.event_created_enabled}
                onChange={() => handleToggle("event_created_enabled")}
              />
              <Form.Check.Label>
                Yangi tadbir yaratilganda
              </Form.Check.Label>
            </Form.Check>

            <Form.Check className="mb-2">
              <Form.Check.Input
                type="checkbox"
                checked={preferences.event_updated_enabled}
                onChange={() => handleToggle("event_updated_enabled")}
              />
              <Form.Check.Label>
                Tadbir o'zgartirilganda
              </Form.Check.Label>
            </Form.Check>

            <Form.Check className="mb-4">
              <Form.Check.Input
                type="checkbox"
                checked={preferences.event_reminder_enabled}
                onChange={() => handleToggle("event_reminder_enabled")}
              />
              <Form.Check.Label>
                Tadbir eslatmalari
              </Form.Check.Label>
            </Form.Check>

            {/* Admin Notifications */}
            <h6 className="mb-3">Boshqa</h6>

            <Form.Check className="mb-4">
              <Form.Check.Input
                type="checkbox"
                checked={preferences.admin_broadcast_enabled}
                onChange={() => handleToggle("admin_broadcast_enabled")}
              />
              <Form.Check.Label>
                Admin e'lonlari
              </Form.Check.Label>
            </Form.Check>

            {/* Channel Preferences */}
            <h6 className="mb-3">Kanal Sozlamalari</h6>

            <Form.Check className="mb-4">
              <Form.Check.Input
                type="checkbox"
                checked={preferences.push_enabled}
                onChange={() => handleToggle("push_enabled")}
              />
              <Form.Check.Label>
                Push bildirishnomalar
              </Form.Check.Label>
            </Form.Check>

            {/* Quiet Hours */}
            <h6 className="mb-3">Tinch soatlar (Bezovta qilmaslik)</h6>

            <Form.Check className="mb-3">
              <Form.Check.Input
                type="checkbox"
                checked={preferences.quiet_hours_enabled}
                onChange={() => handleToggle("quiet_hours_enabled")}
              />
              <Form.Check.Label>
                Tinch soatlarni yoqish
              </Form.Check.Label>
            </Form.Check>

            {preferences.quiet_hours_enabled && (
              <div className="row mb-4">
                <div className="col-md-6">
                  <Form.Group>
                    <Form.Label>Boshlanish vaqti</Form.Label>
                    <Form.Control
                      type="time"
                      value={preferences.quiet_hours_start}
                      onChange={(e) => handleTimeChange("quiet_hours_start", e.target.value)}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group>
                    <Form.Label>Tugash vaqti</Form.Label>
                    <Form.Control
                      type="time"
                      value={preferences.quiet_hours_end}
                      onChange={(e) => handleTimeChange("quiet_hours_end", e.target.value)}
                    />
                  </Form.Group>
                </div>
              </div>
            )}

            <div className="d-flex justify-content-end">
              <Button
                variant="primary"
                onClick={handleSave}
                disabled={saving}
              >
                {saving ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Saqlanmoqda...
                  </>
                ) : (
                  "Saqlash"
                )}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default NotificationSettings;
